import actions from './actions';
import getters from './getters';
import mutations from './mutations';
var state = function state() {
  return {
    total: null,
    products: null,
    suggestions: null,
    description: null,
    provider: null
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};